<template>
  <div class="sidebar">
    <router-link to="/admin/review/">
      <div class="logo-details">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 39.082 39.096"
          class="w-10 h-10 ml-4"
        >
          <defs>
            <linearGradient
              id="a"
              x1="-.569"
              y1="-.524"
              x2="1"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#FFFFFF" />
              <stop offset="1" stop-color="#FFFFFF" />
            </linearGradient>
          </defs>
          <path
            data-name="Intersection 26"
            d="M-11300.909 40.548c-.412 0-.8 0-1.208-.028-.2-.028-.44-.028-.676-.06a4.53 4.53 0 01-.617-.057h-.06c-.06 0-.147-.031-.207-.031-.205-.028-.44-.088-.648-.117-.088-.028-.176-.028-.264-.06a20.761 20.761 0 01-2.327-.588c-.177-.06-.353-.119-.529-.176l-.707-.267c-.057-.028-.088-.028-.148-.057a19.553 19.553 0 01-11.039-11.719c-.058-.2-.146-.44-.205-.648a19.654 19.654 0 01-.824-4.592 4.1 4.1 0 01-.031-.619V21c0-.648.031-1.3.091-1.912.028-.236.057-.443.086-.679a20.78 20.78 0 01.679-3.12c.116-.384.233-.764.381-1.148.031-.088.091-.207.119-.3.088-.236.205-.44.293-.676a18.329 18.329 0 011.443-2.708c.236-.384.531-.767.8-1.148a21.036 21.036 0 011.824-2.12 19.439 19.439 0 0113.839-5.74 19.513 19.513 0 0113.837 5.74 19.642 19.642 0 012.236 2.68q.4.571.795 1.236a19.2 19.2 0 011.12 2.177 5.021 5.021 0 01.293.679c.147.44.295.853.443 1.3a10.421 10.421 0 01.352 1.293c.148.679.265 1.384.355 2.091.028.207.028.443.06.676a16.154 16.154 0 01.028 1.648c0 .415 0 .8-.028 1.179a19.334 19.334 0 01-.827 4.535 19.4 19.4 0 01-4.888 8.124 19.748 19.748 0 01-7.359 4.623 7.085 7.085 0 01-.705.236c-.238.057-.443.117-.65.176-.646.176-1.293.324-1.97.44-.235.031-.443.06-.679.088a2.114 2.114 0 01-.44.06.386.386 0 01-.177.028h-.031a5.352 5.352 0 01-.707.06 5.369 5.369 0 01-.677.028zm-7.508-8.156c.177.207.384.443.56.651a14.894 14.894 0 012.092 3.12c.265.088.528.148.881.236a33.85 33.85 0 00-.528-1.032c-.353-.588-.708-1.179-1.12-1.736a17.818 17.818 0 00-1.176-1.444c-.18-.207-.384-.412-.561-.588a16.664 16.664 0 00-4.211-3.063 7.207 7.207 0 00-.677-.324 16.411 16.411 0 00-2.268-.853c.089.264.236.5.353.764a16.472 16.472 0 002.68 3.8c.324.324.648.648 1 .972a16.8 16.8 0 01-1-3.592 16.2 16.2 0 013.975 3.09zm18.488-8.889a17.218 17.218 0 01.207 2.768 17.323 17.323 0 01-.119 2.205 18.07 18.07 0 01-1.44 5.243c.353-.264.705-.56 1.028-.855a15.582 15.582 0 004.095-5.712 16.34 16.34 0 00-3 1c.057-.617.088-1.236.088-1.881a19.765 19.765 0 00-.236-2.975 21 21 0 014.328-1 10.408 10.408 0 00.028-1.384 16.578 16.578 0 00-.176-2.444c-.028-.236-.088-.44-.119-.648-.47-.028-.91-.06-1.382-.06a16.172 16.172 0 00-4.18.531l-.619.176a16.962 16.962 0 00-3.947 1.736c-.174.119-.353.236-.529.352a19.222 19.222 0 00-2.088 1.62 22.406 22.406 0 00-2.8-3.208 20.706 20.706 0 012.709-2.06c.179-.119.354-.207.531-.324a21.392 21.392 0 013.8-1.8c.236-.06.443-.148.648-.207a20.5 20.5 0 016.331-1c-.116-.207-.235-.412-.353-.619-.088-.145-.176-.264-.267-.409-.205-.324-.412-.619-.617-.915a15.057 15.057 0 00-5.035-.853 15.262 15.262 0 00-3.5.412 20.527 20.527 0 00-3.8-2.268 18.664 18.664 0 016.036-1 17.914 17.914 0 012.824.207 10.657 10.657 0 00-1.147-.767 16.045 16.045 0 00-8.244-2.3 15.72 15.72 0 00-8.155 2.236c-.353.236-.736.472-1.089.736a15.87 15.87 0 012.061-.117 18.537 18.537 0 016.036 1c.295.088.56.207.855.324a19.019 19.019 0 013.855 2.151 5.1 5.1 0 01.648.469 19.717 19.717 0 012.531 2.415 21.465 21.465 0 00-3.8 1.824 15.172 15.172 0 00-2.8-2.532c-.177-.117-.353-.264-.561-.384a15.054 15.054 0 00-3.827-1.765c-.265-.06-.5-.148-.765-.207a15.507 15.507 0 00-3.711-.44 15.44 15.44 0 00-3.885.5 8.651 8.651 0 00-.589.824c-.207.3-.383.588-.56.884-.119.2-.235.412-.353.617a21.314 21.314 0 015.681 1.032 18.264 18.264 0 00-2.3 3.768 15.866 15.866 0 00-4.3-.56h-.588a5.717 5.717 0 00-.116.648 14 14 0 00-.208 2.5c0 .236.031.5.031.764.028.207.028.443.06.648a21.88 21.88 0 013.678.943c.207.088.412.148.619.236a21.316 21.316 0 014 2.06 6.649 6.649 0 01.617.412c.295.207.56.412.855.648.147.117.323.264.5.412.088-.207.176-.412.267-.619a22.91 22.91 0 011.824-3.356 16.6 16.6 0 012.8 3.592 14.34 14.34 0 00-1.268 2.916c-.028.06-.028.119-.057.176a.522.522 0 00-.06.207 1.131 1.131 0 00-.031.324 2.326 2.326 0 00.06.469 1.919 1.919 0 00.267.56 1.574 1.574 0 00.381.384 2.032 2.032 0 00.943.324h.088a1.793 1.793 0 001.029-.355 1.541 1.541 0 00.384-.381 1.486 1.486 0 00.267-.531 2.335 2.335 0 00.057-.469 1.5 1.5 0 00-.028-.355c-.028-.088-.06-.2-.088-.293v-.031a17.584 17.584 0 00-1.268-2.944c-.116-.2-.235-.412-.353-.617a16.972 16.972 0 00-2.8-3.5c-.147-.148-.324-.3-.472-.443a17.23 17.23 0 00-2.18-1.677 14.31 14.31 0 012.18-3.652 24.928 24.928 0 012.8 2.12c.177.148.324.3.472.443a20.68 20.68 0 012.8 3.208c.119.176.235.352.353.529a21.753 21.753 0 012.063 3.947c.146-.148.324-.267.5-.412a6.794 6.794 0 01.736-.56l.619-.443a15.675 15.675 0 00-.972-4.856 17.13 17.13 0 013.973-1.736 18.513 18.513 0 011.239 4.421zm-22.464-.111a16.8 16.8 0 011.148-3.8c.088-.207.176-.384.267-.588a17.659 17.659 0 012.3-3.711c.147-.176.264-.352.411-.529a19.183 19.183 0 012.5-2.415 14.4 14.4 0 013.885 1.679 15.61 15.61 0 00-2.768 2.472c-.148.148-.265.324-.412.5a16.308 16.308 0 00-2.208 3.652 5.1 5.1 0 00-.236.588 14.722 14.722 0 00-.94 4.123 21.536 21.536 0 00-3.947-1.97z"
            transform="translate(11320.4 -1.452)"
            fill="url(#a)"
          />
        </svg>

        <h2 class="logo_name ml-4 text-xl">eHPL</h2>
      </div>
    </router-link>
    <div id="outer">
      <div class="top left"></div>
    </div>
    <li class="inverted-border-radius mb-8 mt-4">
      <i class="bx bx-plus ml-8 mt-4" style="color: #224771"></i>

      <span class="header_text ml-4">
        {{
          finalUrl == "newLicense"
            ? "New License"
            : finalUrl == "renewal"
            ? "Renewal"
            : finalUrl == "goodstanding"
            ? "Goodstanding"
            : ""
        }}</span
      >
    </li>
    <ul class="nav-links">
      <router-link :to="returnClassUrl()">
        <li :class="$route.fullPath == returnClassUrl() ? 'mb-2 active' : ''">
          <a href="#Unassigned">
            <i class="bx bx-certification "></i>

            <span class="links_name"> Unassigned</span>
          </a>
        </li>
      </router-link>
      <router-link :to="returnClassUrl() + 'inReview'">
        <li
          :class="
            $route.fullPath == returnClassUrl() + 'inReview'
              ? 'mb-2 active'
              : ''
          "
        >
          <a href="#inReview">
            <i class="bx bx-refresh "></i>
            <span class="links_name">In Review</span>
            <h6
              v-if="
                statList && statList.filter(el => el.name == 'In Review')[0]
              "
              id="nlIRVCounter"
              class="ml-4 text-primary-600 font-bold text-xl  p-1"
            >
              {{
                statList && statList.filter(el => el.name == "In Review")[0]
                  ? statList.filter(el => el.name == "In Review")[0].statusCount
                  : ""
              }}
            </h6>
          </a>
        </li>
      </router-link>
      <router-link :to="returnClassUrl() + 'draft'">
        <li
          :class="
            $route.fullPath == returnClassUrl() + 'draft' ? 'mb-2 active' : ''
          "
        >
          <a href="#Draft">
            <i class="bx bx-pencil "></i>
            <span class="links_name">Draft</span>
            <h6
              v-if="statList && statList.filter(el => el.name == 'Draft')[0]"
              id="nlIRVCounter"
              class="ml-4 text-primary-600 font-bold text-xl  p-1"
            >
              {{
                statList && statList.filter(el => el.name == "Draft")[0]
                  ? statList.filter(el => el.name == "Draft")[0].statusCount
                  : ""
              }}
            </h6>
          </a>
        </li>
      </router-link>
      <router-link :to="returnClassUrl() + 'approved'">
        <li
          :class="
            $route.fullPath == returnClassUrl() + 'approved'
              ? 'mb-2 active'
              : ''
          "
        >
          <a href="#Approved">
            <i class="bx bx-badge "></i>
            <span class="links_name">Approved</span>
          </a>
        </li>
      </router-link>
      <router-link :to="returnClassUrl() + 'declined'">
        <li
          :class="
            $route.fullPath == returnClassUrl() + 'declined'
              ? 'mb-2 active'
              : ''
          "
        >
          <a href="#Declined">
            <i class="bx bx-error-alt "></i>
            <span class="links_name">Declined</span>
          </a>
        </li>
      </router-link>
      <router-link :to="returnClassUrl() + 'underSupervision'">
        <li
          :class="
            $route.fullPath == returnClassUrl() + 'underSupervision'
              ? 'mb-2 active'
              : ''
          "
        >
          <a href="#Under Supervision">
            <i class="bx bx-folder-open "></i>
            <span class="links_name">Under Supervision</span>
          </a>
        </li>
      </router-link>
      <router-link :to="returnClassUrl() + 'licensed'">
        <li
          :class="
            $route.fullPath == returnClassUrl() + 'licensed'
              ? 'mb-2 active'
              : ''
          "
        >
          <a href="#Licensed">
            <i class="bx bx-badge-check"></i>
            <span class="links_name">Licensed</span>
          </a>
        </li>
      </router-link>

      <router-link :to="returnClassUrl() + 'revoked'">
        <li
          :class="
            $route.fullPath == returnClassUrl() + 'revoked' ? 'mb-2 active' : ''
          "
        >
          <a href="#Licensed">
            <i class="bx bx-trash-alt"></i>
            <span class="links_name">Revoked</span>
          </a>
        </li>
      </router-link>

      <router-link :to="returnClassUrl() + 'suspended'">
        <li
          :class="
            $route.fullPath == returnClassUrl() + 'suspended'
              ? 'mb-2 active'
              : ''
          "
        >
          <a href="#Licensed">
            <i class="bx bx-stop-circle "></i>
            <span class="links_name">Suspended</span>
          </a>
        </li>
      </router-link>

      <router-link :to="returnClassUrl() + 'returned'">
        <li
          :class="
            $route.fullPath == returnClassUrl() + 'returned'
              ? 'mb-2 active'
              : ''
          "
        >
          <a href="#Licensed">
            <i class="bx bx-rotate-left "></i>
            <span class="links_name">Returned</span>
          </a>
        </li>
      </router-link>
    </ul>
    <ul class="nav-links">
      <div class="profile-details mb-8 ml-4">
        <router-link to="/admin/review/">
          <li style="margin-top:100px;">
            <a href="" class="ml-6">
              <i class="bx bx-arrow-to-left text-white"></i>

              <span class="links_name text-white mr-12">Home</span>
            </a>
          </li>
        </router-link>
      </div>
    </ul>
  </div>
</template>
<script>
import { ref } from "vue";
export default {
  props: ["finalUrl"],
  setup(props) {
    let classUrl = "";
    const returnClassUrl = () => {
      props.finalUrl == "newLicense"
        ? (classUrl = "/admin/newLicense/")
        : props.finalUrl == "renewal"
        ? (classUrl = "/admin/renewal/")
        : props.finalUrl == "goodstanding"
        ? (classUrl = "/admin/goodstanding/")
        : "";
      return classUrl;
    };
    let adminStats = ref(
      localStorage.getItem("adminStats")
        ? JSON.parse(localStorage.getItem("adminStats"))
        : []
    );

    let statList = [];

    props.finalUrl == "newLicense"
      ? (statList = adminStats.value.newLicense)
      : props.finalUrl == "renewal"
      ? (statList = adminStats.value.renewal)
      : props.finalUrl == "goodstanding"
      ? (statList = adminStats.value.goodStanding)
      : "";

    return {
      classUrl,
      returnClassUrl,
      statList
    };
  }
};
</script>
